import { render, staticRenderFns } from "./InsurerThemePage.vue?vue&type=template&id=4a582d02&"
import script from "./InsurerThemePage.vue?vue&type=script&lang=js&"
export * from "./InsurerThemePage.vue?vue&type=script&lang=js&"
import style0 from "./InsurerThemePage.vue?vue&type=style&index=0&id=4a582d02&prod&lang=scss&style=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports